@for (key of keys(); track key) {
  <div class="mt-[8px] text-[14px] font-normal leading-[18px] text-red-500">{{
    validationErrors()?.[key]
  }}</div>
}
